import { apiBaseUrl as productApiBaseUrl } from "./api-base-url";
import type { ProductDetailDto } from "./product-types";
import type { ProductListFilter, ProductListViewModel } from "./product-list-data";

export type ProductDetailLoadResult =
  | { status: "ok"; detail: ProductDetailDto }
  | { status: "not-found" }
  | { status: "unavailable" };

export async function loadDatabaseProductDetailDto(goodsId: string, commentPage = 1, commentPageSize = 5): Promise<ProductDetailLoadResult> {
  if (!/^\d+$/.test(goodsId)) {
    return { status: "not-found" };
  }

  const baseUrl = productApiBaseUrl();
  if (!baseUrl) {
    return { status: "unavailable" };
  }

  try {
    const query = new URLSearchParams({
      commentPage: String(Math.max(1, Math.trunc(commentPage))),
      commentPageSize: String(Math.min(50, Math.max(1, Math.trunc(commentPageSize))))
    });
    const response = await fetch(`${baseUrl}/api/products/${encodeURIComponent(goodsId)}?${query.toString()}`, {
      cache: "no-store"
    });
    if (response.status === 404) {
      return { status: "not-found" };
    }
    if (!response.ok) {
      return { status: "unavailable" };
    }

    return { status: "ok", detail: (await response.json()) as ProductDetailDto };
  } catch {
    console.warn("[product-data] database detail unavailable");
    return { status: "unavailable" };
  }
}

export async function loadDatabaseProductListDto(filter: ProductListFilter): Promise<ProductListViewModel | null> {
  const baseUrl = productApiBaseUrl();
  if (!baseUrl) {
    return null;
  }

  const query = new URLSearchParams({
    page: String(filter.page),
    size: "18",
    sort: filter.sort,
  });
  if (filter.category !== "all") {
    query.set("category", filter.category);
  }
  if (filter.style !== "all") {
    query.set("style", filter.style);
  }
  if (filter.key) {
    query.set("key", filter.key);
  }

  try {
    const response = await fetch(`${baseUrl}/api/products?${query.toString()}`, {
      cache: "no-store"
    });
    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as ProductListViewModel;
    return data;
  } catch {
    console.warn("[product-data] database list unavailable");
    return null;
  }
}
